import React from 'react'
import styled from 'styled-components/macro'
import { AnchorLarger, Row, Spaced, GLOBALS } from '.'

type Props = {
  groups: ReadonlyArray<string>
  funktions: ReadonlyArray<{ label: string; value: string }>
  subjects: ReadonlyArray<{ label: string; value: string }>
  subject: string | undefined
  setSubject: (subject: string | undefined) => void
  funktion: string | undefined
  setFunktion: (group: string | undefined) => void
}

export const SearchBar: React.FC<Props> = ({
  groups,
  subject,
  subjects,
  funktions,
  funktion,
  setSubject,
  setFunktion,
  ...restProps
}) => {
  const smoothScrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, group: string) => {
    e.preventDefault()

    const element = document.getElementById(group)
    if (element !== null) {
      const y = element.getBoundingClientRect().top + window.pageYOffset - 68
      window.scrollTo({ top: y, behavior: 'smooth' })
    }
  }

  return (
    <StickyBar {...restProps}>
      <Row align="center" style={{ margin: '0 auto', maxWidth: '1440px', padding: '0 8px', flexWrap: 'wrap' }}>
        <Spaced right>
          {groups.map((groupOption) => (
            <GroupOption
              key={groupOption}
              href={`#${groupOption}`}
              onClick={(e: React.MouseEvent<HTMLAnchorElement>) => smoothScrollToSection(e, groupOption)}
            >
              {groupOption}
            </GroupOption>
          ))}
          <GroupOption
            href="#Alle"
            onClick={(e: React.MouseEvent<HTMLAnchorElement>) => smoothScrollToSection(e, 'Alle')}
          >
            Alle
          </GroupOption>
        </Spaced>
      </Row>
    </StickyBar>
  )
}

const StickyBar = styled.div`
  position: sticky;
  z-index: 100;
  top: 0;
  background: white;
`

const GroupOption = styled(AnchorLarger)`
  cursor: pointer;
  padding: 16px;

  transition: border-color 150ms ease-out;
  border-bottom: 2px solid rgba(0, 0, 0, 0);
  &:hover {
    border-color: ${GLOBALS.colors.tangerineYellow[500]};
  }
`
